import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_6 = {
  key: 1,
  class: "quote-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "quote-main" }
const _hoisted_9 = { class: "quote-copy" }
const _hoisted_10 = { class: "quote-title" }
const _hoisted_11 = { class: "quote-meta" }
const _hoisted_12 = { class: "quote-price" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "quote-side" }

import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { getStatusColor } from "@/shared/utils/utils";
import { useRouter } from "vue-router";
import { useModalStore } from "@/shared/stores/modal";
import AddQuotationModal from "../quotation-detail/AddQuotationModal.vue";
import QuotationOptionsModal from "../quotation-detail/QuotationOptionsModal.vue";

type QuoteItem = {
  id: number | string;
  quoteNo: string;
  title: string;
  price: string;
  date: string;
  status: string;
  icon: string;
  iconTone: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'InquiryDetailQuotesSection',
  props: {
    quotes: { default: () => [] },
    inquiryId: { default: "" }
  },
  setup(__props: any) {

const router = useRouter();
const modal = useModalStore();

const props = __props;

function handleOpenQuote(id: number | string) {
  router.push({
    name: "vendor.quotations.detail",
    params: { id: String(id) },
  });
}

function handleAddQuotation() {
  modal.open(QuotationOptionsModal, {
    inquiryId: props.inquiryId
  }, {
    fullscreen: true,
    showHeader: false,
    title: "Create Quotation",
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "Quotations (" + _toDisplayString(__props.quotes.length) + ")", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(AppButtonFlat, {
        onClick: handleAddQuotation,
        block: "",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { size: "18" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-plus", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" New Quotation ", -1))
        ]),
        _: 1
      })
    ]),
    (!__props.quotes.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_v_icon, {
            size: "20",
            class: "empty-state-icon"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-file-document-outline", -1)
            ]))]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "empty-state-text" }, "Quotations have not been received yet.", -1))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.quotes, (quote) => {
            return (_openBlock(), _createElementBlock("div", {
              key: String(quote.id),
              class: _normalizeClass(["quote-card", { 'quote-card--clickable': true }]),
              onClick: ($event: any) => (handleOpenQuote(quote.id))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(["quote-icon icon-bg", quote.iconTone])
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-file-check-outline", -1)
                    ]))]),
                    _: 1
                  })
                ], 2),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(quote.quoteNo), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(quote.price), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "quote-dot" }, null, -1)),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(quote.date), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_v_chip, {
                  label: "",
                  color: _unref(getStatusColor)(quote.status),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(quote.status), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]),
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "quote-chevron"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 8, _hoisted_7))
          }), 128))
        ]))
  ]))
}
}

})